var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isPromotionBarActive,
          expression: "isPromotionBarActive",
        },
      ],
      staticClass: "promotion-bar",
      attrs: { role: "complementary" },
    },
    [
      _c(
        "a",
        {
          attrs: { href: _vm.iStagingUrl, target: "_blank" },
          on: { click: _vm.clickLogo },
        },
        [
          _c("img", {
            staticClass: "promotion-bar-logo",
            attrs: { src: _vm.iStagingBrand, alt: "iStaging" },
          }),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "promotion-bar-caption" }, [
        _c("p", { staticClass: "promotion-bar-text" }, [
          _vm._v("\n      " + _vm._s(_vm.$t("promotionText")) + "\n    "),
        ]),
        _vm._v(" \n    "),
        _c(
          "a",
          {
            staticClass: "promotion-bar-link",
            attrs: { href: _vm.promotionUrl, target: "_blank" },
            on: { click: _vm.clickPromotionLink },
          },
          [_vm._v("\n      " + _vm._s(_vm.$t("promotionLinkText")) + "\n    ")]
        ),
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "promotion-bar-button",
          attrs: { type: "button" },
          on: { click: _vm.closePromotionBar },
        },
        [_c("icon", { staticClass: "icon-close-info-black" })],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }